export default __webpack_public_path__ + "static/emi-b2123182e24c4d1fafbb8fc5fbb16cac.jpg";